export default __webpack_public_path__ + "static/media/06.ffd13f54.jpg";